import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { ActionAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { NotificationServiceInstance } from "../../../../../../shared/services/notification.service";
import { EventBus } from "../../../../../Controls/EventBus";
import EventConstants from "../../../../../Controls/EventConstants";
import { ParametresInstance } from "../../../../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../../../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../../../../../modalComponents/modalAlerte/modalAlerte";
import ModalChangerEtatAbsence from "../../../../modals/modalChangerEtatAbsence/modalChangerEtatAbsence";
import DataTestIDHelper from "../../../../../../Helper/DataTestID/DataTestIDHelper";

@Component({
    components: {
        ModalChangerEtatAbsence: require("../../../../modals/modalChangerEtatAbsence/modalChangerEtatAbsence.vue.html"),
    },
})
export default class DemandeEnAttente extends Vue {
    public colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
    public curentOrberColumn = "DateDebut";
    public orderingDesc = false;
        
    @Prop()
    public demandeEnAttente: AbsenceSalarieDto[] = [];

    public validerAbsenceCheckSolde(absence: AbsenceSalarieDto): void {

        let action = ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_1;
        if (absence.Etat === EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
            action = ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_2;
        }
        else if (absence.Etat !== EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1) {
            NotificationServiceInstance.SendWarning(`L'absence ne peut pas être validée car elle est ${ParametresInstance.getLibelleEtatAbsence(absence.Etat)}`);
            return;
        }

        ServicesFactoryInstance.StatuAbsenceService.getSalarieById(absence.IdSalarie, data => {
            let cpRestantNMoinsUn = data.CPAcquis < data.CPPris ? 0 : (data.CPAcquis - data.CPPris);
            let cpRestantN = data.CPDroitsOuverts - (data.CPAcquis < data.CPPris ? (data.CPPris - data.CPAcquis) : 0);
            let cpRestantTotal = cpRestantNMoinsUn + cpRestantN;

            if (absence.NombreJours !== undefined && absence.NombreJours > cpRestantTotal) {
                const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                    message: "Le reliquat de congés du salarié n'est pas suffisant pour couvrir la demande. Souhaitez-vous vraiment valider la demande ?",
                    callBackYes: () => {
                        this.afficherModalChangerEtatAbsence(absence, action);
                    },
                    callBackNo: () => { }
                });

                EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
            } else {

                this.afficherModalChangerEtatAbsence(absence, action);
            }
        })
    }

    public refuserAbsence(absence: AbsenceSalarieDto): void {

        if (absence.Etat !== EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1
            && absence.Etat !== EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
            NotificationServiceInstance.SendWarning(`L'absence ne peut pas être refusée car elle est ${ParametresInstance.getLibelleEtatAbsence(absence.Etat)}`);
            return;
        }

        this.$emit("afficherModalChangerEtatAbsence", absence, ActionAbsencesEnum.RefuserAbsenceParResponsable);
    }

    public afficherModalChangerEtatAbsence(absence: AbsenceSalarieDto, action: ActionAbsencesEnum): void {
        this.$emit("afficherModalChangerEtatAbsence", absence, action);
    }

    public randomColor(color: string): string {
        const r = () => Math.floor(256 * Math.random());

        return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
    }

    public orderBy(columnName: string): void {
        if (this.curentOrberColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }

        this.curentOrberColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.curentOrberColumn;

        if (this.demandeEnAttente != undefined) {
            this.demandeEnAttente = this.demandeEnAttente.sort(function (a, b) {
                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        return (columnName == this.curentOrberColumn && this.orderingDesc == desc) ? "active" : "";
    }
    
    public getManagerAbsenceRequestEntryDataTestID(absence: AbsenceSalarieDto, suffix: string): string {
        var employeeFullName = absence.NomSalarie?.toLowerCase() + "_" + absence.PrenomSalarie?.toLowerCase();
        return DataTestIDHelper.getAbsenceRequestDataTestID(absence.LibelleTypeAbsence, absence.DateDebut, absence.DateFin, "manager-requestsList-" + employeeFullName + "-" , suffix);
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceManager/tableaux/demandeEnAttente/demandeEnAttente.ts